import React from 'react';
import { AgentPicture } from './AgentPicture';
export var BASIC_AGENT_PROFILE_PHOTO_URL = 'https://www.static-immobilienscout24.de/statpic/agent-profile-page-web/fd3e55f5d389a8b0baa86c1e830b0866_placeholder.png';
var getAgentPhotoUrl = function getAgentPhotoUrl(photoUrl, isBasicBranchenbuchAgent) {
  if (isBasicBranchenbuchAgent) {
    return BASIC_AGENT_PROFILE_PHOTO_URL;
  } else {
    return photoUrl;
  }
};
export var AgentPictureWrapper = function AgentPictureWrapper(_ref) {
  var pictureUrl = _ref.pictureUrl,
    isBasicBranchenbuchAgent = _ref.isBasicBranchenbuchAgent,
    badges = _ref.badges;
  pictureUrl = getAgentPhotoUrl(pictureUrl, isBasicBranchenbuchAgent);
  return /*#__PURE__*/React.createElement(AgentPicture, {
    pictureUrl: pictureUrl,
    badges: badges
  });
};